import "../../../../shared/styles/flags/Flags.css";

import { FC } from "react";

import FlagContainer from "../styles/FlagContainer.styled";

interface FlagProps {
  codeAlpha2?: string;
  direction: "ltr" | "rtl";
}

const Flag: FC<FlagProps> = ({ codeAlpha2, direction }) => {
  if (!codeAlpha2) {
    return null;
  }

  return (
    <FlagContainer direction={direction}>
      <div className={`fflag fflag-${codeAlpha2}`} />
    </FlagContainer>
  );
};

export default Flag;
